/**
 * Single source for lead phone + WhatsApp URLs used across CTAs (floating buttons,
 * hero, header, conversion sections). Change the number or default messages here only.
 */
export const LEAD_PHONE_E164 = '+919265472938';
export const LEAD_PHONE_DISPLAY = '+91 92654 72938';
export const LEAD_TEL_HREF = `tel:${LEAD_PHONE_E164}`;

const WA_BASE = 'https://wa.me/919265472938';

export function leadWhatsAppUrl(encodedMessage) {
  return `${WA_BASE}?text=${encodeURIComponent(encodedMessage)}`;
}

export const LEAD_WHATSAPP_URL_HERO = leadWhatsAppUrl(
  'Hello, I am interested in your services in Ahmedabad. Please share details.'
);

export const LEAD_WHATSAPP_URL_CTA = leadWhatsAppUrl(
  'Hello, I need professional facility services in Ahmedabad. Please call me back with details.'
);
